import React, { useRef } from 'react';
import cn from '../../lib/bem';

import './inputVerification_component.scss';

const InputVerificationComponent = ({ length, value, accion }) => {

    const classes = cn("inputVerificationComponent");
    
    const inputs = useRef([]);

    const processInput = (e, slot) => {
        const num = e.target.value;
        if (/[^0-9]/.test(num)) return;
        const newCode = [...value];
        newCode[slot] = num;
        accion(newCode);
        if (slot !== length - 1) {
            inputs.current[slot + 1].focus();
        }
    };

    const onKeyUp = (e, slot) => {
        if (e.keyCode === 8 && !value[slot] && slot !== 0) {
          const newCode = [...value];
          newCode[slot - 1] = "";
          accion(newCode);
          inputs.current[slot - 1].focus();
        }
    };

    return (
        <div className={classes()}>
            <div className="code-inputs">
                {
                    value.map((num, idx) => {
                        return (
                            <input
                                data-testid={idx}
                                key={idx}
                                type="text"
                                inputMode="numeric"
                                maxLength={1}
                                value={num}
                                autoFocus={!value[0].length && idx === 0}
                                onChange={e => processInput(e, idx)}
                                onKeyUp={e => onKeyUp(e, idx)}
                                ref={ref => inputs.current.push(ref)}
                            />
                        );
                    })
                }
            </div>
        </div>
    );

}

export default InputVerificationComponent;
